module.exports = __webpack_public_path__ + "img/qgjj-04.prt.aad4567c.jpg";